// extracted by mini-css-extract-plugin
export default {"panel":"styles_panel_QP7Zz","dragPanel":"styles_dragPanel__wKh6","tableWrapper":"styles_tableWrapper_dnj9D"};